// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KTlR","col":"styles_col__3I7Ce","actions":"styles_actions__2eVnI","conflict":"styles_conflict__3tNpM"};